// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"450ce24e","38":"41646572","74":"402113c4","203":"34759e3e","223":"52034ac0","239":"ef7fe7b8","351":"88962ab0","469":"d2286bd4","536":"274dbd9f","709":"c6d85435","732":"7290c1a9","977":"017beeb8"}[chunkId] + ".chunk.js";
};